import { useTranslation } from "react-i18next";
import axios from "axios";
import { isObject } from "lodash";
import { UnavailabilityError } from "../pages/objects/unavailabilityError";
import { EditUnavailabilityError } from "../pages/objects/editUnavailabilityError";

type Callback = (error: {
    reason?: string,
    message: string,
} | Error) => {
    reason?: string,
    message: string,
};

export function useExtraErrorMessage(): Callback {
    const { t } = useTranslation();

    return (error) => {
        let result: {
            reason?: string,
            message: string
        } = {
            message: ''
        };
        if (axios.isAxiosError(error)) {
            if (error.response) {
                if (error.response.status === 400 || error.response.status === 404) {
                    if (isObject(error.response.data)) {
                        for (const [key, value] of Object.entries(error.response.data)) {
                            const keyText = t(`shared.${key}`);
                            if (Array.isArray(value)) {
                                result.message += `${keyText} : ${value.join('\n')}\n`;
                            } else {
                                result.message += `${keyText} : ${value}\n`;
                            }
                        }
                    } else {
                        result.message = error.message;
                    }
                } else if (error.response.status === 401 || error.response.status === 403) {
                    result.message = t('errors.permissions');
                } else if (error.response.status === 409) {
                    result.message = t('errors.conflict') + ': ' + error.response.data?.error;
                } else if (error.response.status === 500) {
                    result.message = t('errors.servers');
                }
            }
        } else {
            result.message = error.message;
        }

        if (error instanceof UnavailabilityError) {
            result.reason = t('cms.circuit-steps.disponibility');
        }

        if (error instanceof EditUnavailabilityError) {
            result.reason = t('cms.circuit-steps.disponibility');
            result.message = t('cms.circuit-steps.edit-disponibility');
        }

        if ('reason' in error) {
            result.reason = error.reason;
        }

        return result;
    };
}
